import { translate } from '@/translation/translate.ts';

import { ICONS } from '@/Icons.tsx';
import { Slide } from '@/eventConfig/types.ts';
import { useEventConfig } from '@/eventConfig/useEventConfig';

export const useSlideIcons = (slide: Slide) => {
  const { eventConfig } = useEventConfig();

  return {
    nextLabel: translate(slide?.nextLabel) || translate(eventConfig?.translations.next),
    nextIcon: ICONS[slide?.nextIcon || 'next'],
    prevLabel: translate(slide?.prevLabel) || translate(eventConfig?.translations.back),
    prevIcon: ICONS[slide?.prevIcon || 'prev'],
    cancelLabel: translate(slide?.cancelLabel) || '',
    cancelIcon: ICONS[slide?.cancelIcon || 'cancel'],
    infoLabel: translate(slide?.infoLabel) || translate(eventConfig?.translations.why),
    infoIcon: ICONS[slide?.infoIcon || 'info'],
  };
};

export default useSlideIcons;
